import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'

Vue.use(Vuex)

export function createStore () {
  return new Vuex.Store({
    state: {
      activeType: null,
      detailData: {},
      header: {},
      footer: {},
      friendList: [],
      advantageCon: {},
      purchaseCon: {},
      indexTitle: [],
      describeData: [],
      journalismConData: {},
      solutionStaticData: {},
      industryCon: [],
      districtCon: [],
      downloadDetailData: {},
      solutionList: [],
      solutionCardsData: {},
      solutionListData: {},
      solutionLayoutData: {},
      solutionNameData: '',
      newsList: [],
      newsContent: {},
      clientDataList: []
    },
    actions,
    mutations
  })
}



// WEBPACK FOOTER //
// ./src/store/index.js